<template>
  <div class="content-container flex-column">
    <!-- Kontrakt Toolbar -->
    <div class="grid-x toolbar fixed responsive-small-only">
      <div class="cell auto toolbar-responsive">
        <ul class="toolbar-title-breadcrumbs">
          <li>
            <a href="javascript:;" @click="hideKundeKontrakt()">Kontrakter</a>
            <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-arrow-right"></use></svg>
          </li>
          <li>
            <a href="javascript:;">{{ kontrakt.Kontraktnr }}</a>
            <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-arrow-right"></use></svg>
          </li>
        </ul>
      </div>

      <div class="cell shrink toolbar-responsive">
        <span class="button-container has-popover" :class="{'popover-active': actionsPopoverActive}" @click="toggleActionsPopover()">
          <a href="javascript:;" class="button action glyph glyph-only"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-more"></use></svg></a>
          <span class="popover align-x-right align-y-bottom medium">
            <ul>
              <li v-if="totalObjektCount > 0"><a href="javascript:;" @click="showPrintLabelModal()"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-print"></use></svg> <span>Skriv ut etiketter</span></a></li>
              <li v-else class="disabled"><a href="javascript:;"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-print"></use></svg> <span>Skriv ut etiketter</span></a></li>
              <li v-if="isDeletable"><a href="javascript:;" @click="showDeleteConfirm()"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-delete"></use></svg> <span>Slett kontrakt</span></a></li>
              <li v-else class="disabled"><a href="javascript:;"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-delete"></use></svg> <span>Slett kontrakt</span></a></li>
            </ul>
          </span>
        </span>
        <ul class="button-group">
          <li>
            <a href="javascript:;" @click="openKontraktNotaterSidebar()" class="button action glyph glyph-only-small data-modal">
              <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-comment"></use></svg>
              <span v-if="totalNotatCount">Kontraktsnotater <span class="notifications-count">{{totalNotatCount}}</span></span>
              <span v-else>Kontraktsnotater</span>
            </a>
          </li>
          <li>
            <a href="javascript:;" @click="openKontraktHistorikkSidebar()" class="button action glyph glyph-only-small data-modal">
              <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-history"></use></svg>
              <span>Historikk</span>
            </a>
          </li>
          <li>
            <a href="javascript:;" class="button action glyph glyph-only-small" @click="printAction()"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-print"></use></svg> <span>Skriv ut og send</span></a>
          </li>
        </ul>

        <a href="javascript:;" @click="$emit('switchKontraktView', true)" class="button action glyph-only-small glyph"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-edit"></use></svg> <span>Rediger</span></a>
      </div>
    </div>

    <!-- Content -->
    <div class="content-container flex-row no-flex-grow">
      <section class="content xlarge-padding border-bottom">
        <div class="grid-x grid-padding-x grid-padding-large">

          <!-- Left & Middle -->
          <div class="cell large-6 xlarge-6 xxlarge-7 xxxxlarge-8">
            <div class="grid-x grid-padding-x grid-padding-large">

              <!-- Section Left -->
              <div class="cell large-12 xxlarge-6">
                <div class="data-grid border-right">
                  <div class="grid-x grid-padding-x grid-padding-small">
                    <div class="cell">
                      <h3 class="icon-heading">
                        <span class="icon"><svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-contract"></use></svg></span>
                        <span class="icon-heading-title">
                          <span class="title">Kontrakt {{kontrakt.Kontraktnr}}</span>
                          <span class="subtitle" v-if="!objektListLoading">
                            {{kontrakt.kontrakttype.info}} / {{totalObjektCount > 0 ? totalObjektCount : 'Ingen'}} objekter
                          </span>
                          <span class="subtitle" v-else>
                            {{kontrakt.kontrakttype.info}}
                          </span>
                        </span>
                      </h3>
                    </div>

                    <div class="cell small-4 large-4 border-top">
                      <div class="dl-wrap">
                        <span class="dl dt">Avdeling</span>
                        <span class="dl dd">{{kontrakt.avdeling ? kontrakt.avdeling.Beskrivelse : '-'}}</span>
                      </div>
                    </div>

                    <div class="cell small-4 large-4 border-top">
                      <div class="dl-wrap">
                        <span class="dl dt">Opprettet</span>
                        <span class="dl dd">{{kontrakt.Registrert_dato | avantidatetime}}</span>
                      </div>
                    </div>

                    <div class="cell small-4 large-4 border-top">
                      <div class="dl-wrap">
                        <span class="dl dt">Endret</span>
                        <span class="dl dd">{{kontrakt.Sist_endret_tid | avantidatetime}}</span>
                      </div>
                    </div>

                    <div class="cell small-12 large-12 border-top" v-if="kontrakt.Kontraktinfo">
                      <span class="title label">{{kontrakt.Kontraktinfo}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- End Section Left -->

              <!-- Section Middle -->
              <div class="cell large-12 xxlarge-6">
                <div class="data-grid">
                  <div class="grid-x grid-padding-x grid-padding-small">
                    <div class="cell small-4 large-4 border-bottom">
                      <div class="dl-wrap">
                        <span class="dl dt">Salær</span>
                        <span class="dl dd">{{kontrakt.Salar || 0}}%</span>
                      </div>
                    </div>

                    <div class="cell small-4 large-4 border-bottom">
                      <div class="dl-wrap">
                        <span class="dl dt">Forsikring</span>
                        <span class="dl dd">{{kontrakt.Forsikring || 0}}%</span>
                      </div>
                    </div>

                    <div class="cell small-4 large-4 border-bottom">
                      <div class="dl-wrap">
                        <span class="dl dt">Finders fee</span>
                        <span class="dl dd">{{kontrakt.FindersFee || 0}}%</span>
                      </div>
                    </div>

                    <div class="cell">
                      <div class="grid-x">
                        <div class="cell auto" v-if="kontrakt.mottaker">
                          <span class="avatar" :class="strToAvatarClass(kontrakt.mottaker.initials)">{{kontrakt.mottaker.initials}}</span>
                          <div class="dl-wrap">
                            <span class="dl dt">Kontraktansvarlig</span>
                            <span class="dl dd">{{kontrakt.mottaker.full_name}}</span>
                          </div>
                        </div>
                        <div class="cell auto" v-else>
                          <span class="avatar" :class="strToAvatarClass('-')">-</span>
                          <div class="dl-wrap">
                            <span class="dl dt">Kontraktansvarlig</span>
                            <span class="dl dd">Ingen</span>
                          </div>
                        </div>
                        <div class="cell shrink">
                          <span v-if="kontrakt.Registrertsignert" class="status green" :title="kontrakt.Registrertsignert">Signert</span>
                          <span v-else class="status" :class="kontraktStatusClass(kontrakt.status)">{{kontrakt.status_text}}</span>
                          <!--
                          <span class="status red" v-if="!kontrakt.Sist_skrevet_ut">Kladd</span>
                          <span v-else>
                            <span class="status orange" v-if="!kontrakt.Registrertsignert">Sent til kunde</span>
                            <span class="status green" v-else>Signert</span>
                          </span>
                          -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- End Section Middle -->

            </div>
          </div>
          <!-- End Left & Middle -->

          <!-- Section Right -->
          <div class="cell auto xxxxlarge-4">
            <div class="grid-x grid-padding-x grid-padding-large">
              <div class="cell large-12">
                <div class="data-grid">
                  <div class="card">
                    <span class="contract-visibility" v-if="kontrakt.GodkjendtForInternett === 'T'">
                      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-visible"></use></svg>
                      Synlig for selger
                    </span>
                    <span class="contract-visibility" v-else>
                      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-invisible"></use></svg>
                      Ikke synlig for selger
                    </span>

                    <div class="grid-x grid-padding-x grid-padding-small">
                      <div class="cell">
                        <h3 class="icon-heading">
                          <span class="icon"><svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-user"></use></svg></span>
                          <span class="icon-heading-title">
                            <span class="title">Selger</span>
                            <span class="subtitle">
                              <a class="sellerlink" :href="'/kunde/' + kunde.Kundenr">{{kunde.Bedrift ? kunde.FirmaNavn : kunde.full_name}}</a>
                            </span>
                            <span class="subtitle" style="margin-top: 2px;">
                              <a class="sellerlink" href="javascript:;" @click="showEmailModal">Purremail selger</a>
                            </span>
                          </span>
                        </h3>
                      </div>

                      <div class="cell large-4 border-top">
                        <div class="dl-wrap">
                          <span class="dl dt">Legitimasjon</span>
                          <span class="dl dd" v-if="!kontrakt.legitimasjon">
                            Ingen legitimasjon
                          </span>
                          <span class="dl dd" v-else>
                            {{kontrakt.legitimasjon.Tekst}}
                            <span class="statusicon verified" v-if="kontrakt.Legitimert">
                              <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-success"></use></svg>
                            </span>
                            <span class="statusicon unverified" v-else>
                              <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                            </span>
                          </span>
                        </div>
                      </div>

                      <div class="cell large-4 border-top">
                        <div class="dl-wrap">
                          <span class="dl dt">Kontonummer</span>
                          <span class="dl dd">{{kontrakt.Kontonummer ? kontrakt.Kontonummer : '-'}}</span>
                        </div>
                      </div>

                      <div class="cell large-4 border-top">
                        <div class="dl-wrap">
                          <span class="dl dt">Kontrakt signert</span>
                          <span class="dl dd">
                            <TheSwitchInput v-model="form.signert" :disabled="!canChangeSignert" :small="true" containerClassName="" labelTrue="Ja" labelFalse="Nei" :trueValue="true" :falseValue="false" @input="onSignertChange()"/>
                          </span>
                          <!--
                          <span class="dl dd" v-if="!kontrakt.Registrertsignert">Nei</span>
                          <span class="dl dd" v-else>{{kontrakt.Registrertsignert | avantidatetime}}</span>
                          -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- End Section Right -->

        </div>
      </section>
    </div>

    <!-- Objekt -->
    <KundeKontraktObjektList :key="kontrakt.Kontraktnr" :kunde="kunde" :kontrakt="kontrakt"/>
  </div>
</template>

<script>
import KundeKontraktObjektList from './KundeKontraktObjektList'
import KundeService from '@/services/KundeService'
import bus from '@/plugins/event-bus'
import { mapGetters } from 'vuex'

export default {
  name: 'KundeKontraktShow',
  components: {
    KundeKontraktObjektList
  },
  props: {
    kunde: {
      type: Object,
      required: true
    },
    kontrakt: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      form: {},
      canChangeSignert: true,
      actionsPopoverActive: false
    }
  },
  created: function () {
    bus.$off('kunde-address-updated-kontrakt')

    if (this.$store.getters['kundekontraktobjekt/needreload']) {
      this.$store.dispatch('kundekontraktobjekt/load', this.kontrakt)
    }

    if (this.$store.getters['kontraktnotat/needreload']) {
      this.$store.dispatch('kontraktnotat/load', {
        Kundenr: this.kunde.Kundenr,
        Kontraktnr: this.kontrakt.Kontraktnr
      })
    }

    if (this.$store.getters['kontrakthistory/needreload']) {
      this.$store.dispatch('kontrakthistory/load', {
        Kundenr: this.kunde.Kundenr,
        Kontraktnr: this.kontrakt.Kontraktnr
      })
    }

    var vm = this
    window.jQuery(document).mouseup(function (e) {
      var container = window.jQuery('.has-popover')
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        vm.actionsPopoverActive = false
      }
    })

    this.form.signert = this.kontrakt.Registrertsignert !== null
  },
  mounted () {
    bus.$on('kunde-address-updated-kontrakt', (data) => this.onKundeAddressUpdated(data))
  },
  computed: {
    ...mapGetters({
      totalNotatCount: 'kontraktnotat/totalCount',
      totalObjektCount: 'kundekontraktobjekt/totalCount',
      objektListLoading: 'kundekontraktobjekt/loading'
    }),
    isDeletable: function () {
      return this.kontrakt.total_objekt === null || this.kontrakt.total_objekt < 1
    },
    hasAddress: function () {
      // No kundeadresse
      if (!this.kunde.kundeadresse || this.kunde.kundeadresse.length < 1) {
        return false
      }

      let f = this.kunde.kundeadresse.filter(i => i.Type === 'faktura')
      let l = this.kunde.kundeadresse.filter(i => i.Type === 'levering')

      // No faktura adresse
      if (!f || f.length < 1) {
        return false
      }

      // No levering adresse
      if (!l || l.length < 1) {
        return false
      }

      return true
    }
  },
  methods: {
    showEmailModal: function () {
      this.openModal(
        'kunde-email-modal',
        {
          type: 'kontrakt-mangler',
          data: { kontrakt: this.kontrakt },
          kunde: this.kunde
        },
        'medium'
      )
    },
    toggleActionsPopover: function () {
      this.actionsPopoverActive = !this.actionsPopoverActive
    },
    showPrintLabelModal: function () {
      this.openModal(
        'print-labels-modal',
        {
          kontrakt: this.kontrakt
        },
        'medium'
      )
    },
    showDeleteConfirm: function () {
      let vm = this

      this.openConfirm(
        'Slett kontrakt #' + this.kontrakt.Kontraktnr,
        'Er du sikker på at du vil slette kontrakten?',
        'Ja',
        'Nei',
        function () {
          KundeService.deleteKundeKontrakt(vm.kontrakt.Kundenr, vm.kontrakt.Kontraktnr)
            .then((response) => {
              vm.closeModal()
              bus.$emit('kunde-kontrakt-deleted', response.data)
            })
            .catch(() => {
              vm.closeModal()
              vm.$helpers.showErrorAlert('Feil', 'Kunne ikke slette kontrakten')
            })
        },
        function () {
          vm.closeModal()
        }
      )
    },
    onSignertChange: function () {
      this.canChangeSignert = false

      KundeService.saveKundeKontrakt(this.kunde.Kundenr, this.kontrakt.Kontraktnr, { 'set_signed': this.form.signert })
        .then((response) => {
          // bus.$emit('kontrakt-signert-changed') // Listener in objetklist: So we reload the list
          bus.$emit('kunde-kontrakt-updated', response.data)

          // Show success alert
          this.$helpers.showSuccessAlert('Kontraktstatus har blitt endret')
        })
        // eslint-disable-next-line
        .catch((error) => {
          this.form.signert = !this.form.signert
        })
        .then(() => {
          this.canChangeSignert = true
        })
    },
    printAction: function () {
      if (!this.hasAddress) {
        this.$helpers.showErrorAlert('Feil', 'Selger mangler adresse information')
        this.openModal(
          'kunde-adresse-modal',
          {
            kunde: this.kunde,
            event: 'kunde-address-updated-kontrakt'
          }
        )
      } else {
        this.openModal('kunde-kontrakt-print-modal',
          { kunde: this.kunde, kontrakt: this.kontrakt, internalWindow: true },
          'split'
        )
      }
    },
    onKundeAddressUpdated: function (data) {
      this.$helpers.showSuccessAlert('Kundeadresse er lagret')

      // UGLY Hack, as we should have had kunde in a store instread. But this works for now.
      this.$set(this.kunde, 'kundeadresse', data.kundeadresse)
      this.$set(this.kunde, 'Tlfprivat', data.Tlfprivat)
      this.$set(this.kunde, 'Tlfarbeid', data.Tlfarbeid)
      this.$set(this.kunde, 'Mobil', data.Mobil)
      this.$set(this.kunde, 'Kontonr', data.Kontonr)
      this.$set(this.kunde, 'Email', data.Email)

      bus.$emit('kunde-updated', data)
    },
    openKontraktNotaterSidebar: function () {
      this.openModal('kunde-kontrakt-sidebar-notater', {kunde: this.kunde, kontrakt: this.kontrakt}, 'right')
    },
    openKontraktHistorikkSidebar: function () {
      this.openModal('kunde-kontrakt-sidebar-historikk', {kunde: this.kunde, kontrakt: this.kontrakt}, 'right')
    },
    hideKundeKontrakt: function () {
      bus.$emit('hide-kunde-kontrakt')
    }
  }
}
</script>
<style scoped>
  a.sellerlink {
    color:blue;
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktShow.vue